@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../app-brand/concepts/shipstation-concept-layer-default.module.less';
@import './batch-menu-toggler.module.less';
@import './batch-section.module.less';

.add-to-batch-menu {
  position: absolute;

  width: 100%;
  bottom: 0;

  // hide the batch menu when closed
  &:not(.open) {
    .menu-contents {
      display: none;
    }
  }
}

.menu-contents {
  background: var(--add-to-batch-menu--background-color);
}

.batch-list {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-4;
  padding: @space-4;

  max-height: 30vh;
  overflow-y: scroll;
}

// toggler
@BatchMenuToggler();

// rows
@AddToBatchMenuSection();

// buttons
@buttonBaseStyles: {
  padding: @space-8 @space-16;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: @space-8;

  color: var(--add-to-batch-menu--text-color);
  font-size: 14px;
  line-height: 20px;

  &:hover {
    background: var(--add-to-batch-menu--button--hover--background-color);
  }

  &:focus:not(:active) {
    outline: 2px solid var(--add-to-batch-menu--button--keyboard-focus--outline-color);
    outline-offset: -@space-4;
  }
};

.load-more-button {
  @buttonBaseStyles();
  padding-left: @space-40;
}

.create-new-batch-button {
  @buttonBaseStyles();

  .plus-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;

    > svg {
      width: 12px;
      height: 12px;
    }
  }
}
